const generateRandomKey = (length = 24) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i += 1) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
};

const formDataTemplateGenerator = (inputs) => {
  const formData = {};
  inputs?.map((ic) => {
    switch (ic.__component) {
      case "forms.form-item":
        if (!!ic?.value) {
          formData[ic?.name] = ic?.value;
        }
        break;
      case "forms.select-field":
        if (ic?.items.filter((item) => item.selected === true).length > 0) {
          formData[ic?.name] = ic?.items.filter(
            (item) => item.selected === true
          )[0].value;
        }
        break;
      case "forms.radio-field":
        if (ic?.items.filter((item) => item.selected === true).length > 0) {
          formData[ic?.name] = ic?.items.filter(
            (item) => item.selected === true
          )[0].value;
        }
        break;
      case "forms.checkbox":
        if (ic?.items.filter((item) => item.selected === true).length > 0) {
          let selectedOptions = [];
          ic?.items
            .filter((item) => item.selected === true)
            .map((item) => {
              selectedOptions.push(item.value);
            });
          formData[ic?.name] = selectedOptions;
        }
        break;
      case "forms.email-field":
        if (!!ic?.value) {
          formData[ic?.name] = ic?.value;
        }
        break;
      case "forms.hidden-field":
        if (ic?.randomKey) {
          formData[ic?.name] = generateRandomKey(24);
        } else if (!!ic?.value) {
          formData[ic?.name] = ic?.value;
        }
        break;
      default:
    }
  });

  return formData;
};

export default formDataTemplateGenerator;
